import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import fieldPropTypes from './field';
import upcomingPropTypes from './upcoming';

const { arrayOf, bool, number, shape, string } = PropTypes;

export default shape({
  adminUsers: arrayOf(string),
  allowPublicEmailTrigger: bool,
  category: string,
  createdBy: string,
  createdDate: string,
  description: string,
  displayName: string,
  fields: arrayOf(fieldPropTypes),
  fieldVisibility: string,
  fieldVisibleToUsers: arrayOf(string),
  maximumDuration: string,
  onStartMenu: bool,
  owner: string,
  priority: string,
  processID: string,
  processName: string,
  published: bool,
  standardUsers: arrayOf(string),
  stepCount: number,
  teamName: string,
  thumbnail: string,
  upcoming: arrayOf(upcomingPropTypes)
});



// WEBPACK FOOTER //
// ./js/types/api/process.js